// Copyright (c) 2019 Deere & Company
import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FileUploadPanel from './file-upload-panel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../shared/services/customize-error-alert-bar';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { uploadBatchTextData } from '../repositories';
// import { Accordion } from 'react-bootstrap';
import _ from 'lodash';
import { downloadSampleReports } from '../../claims/repositories';

class BatchTextUpload extends Component {

    state = {
        fileInfo: { },
        uploadResp: '',
        uploadStatus: ''
    }

    componentDidMount () {

        this.props.increaseCounter();
        setTimeout( () => {

            this.props.decreaseCounter();

        }, 500 );

    }

    handleFileDrop = files => {

        this.setState( {
            fileInfo: files[0],
        } );

    }

    handleRejectedFiles = () => {

        this.props.increaseCounter();
        const msg = 'Only CSV files are allowed';
        customizeErrorAlert( msg );
        this.props.decreaseCounter();

    }

    handleSubmitClick = () => {
        this.setState({
            uploadResp: '',
            uploadStatus: ''
        });

        this.props.increaseCounter();
        uploadBatchTextData(this.state.fileInfo).then(response => {
            if (response.errors.length) {
                response.errors.forEach(element => {
                    customizeErrorAlert(element);
                });
            } else {
                this.setState({
                    uploadResp: response.uploadStatisticsMap,
                    uploadStatus: response.status
                });
            }
            this.props.decreaseCounter();
        }).catch(() => {
            this.props.decreaseCounter();
        });
    }


    handleCancleClick = () => {

        this.setState( {

            fileInfo: { },
            uploadResp: '',
            uploadStatus: '',

        } );

    }

    handleDownloadClick = (fileName) => () => {
        console.log("fileName", fileName);
        
        this.props.increaseCounter();

        downloadSampleReports(fileName)
            .then(response => {
                response.blob().then( blob => {

                    const url = window.URL.createObjectURL( blob );
                    const a = document.createElement( 'a' );
                    a.setAttribute( 'download', fileName+'.csv' );
                    a.href = url;
                    document.body.appendChild( a );
                    a.click();
                    a.parentNode.removeChild( a );
            
                } );
                this.props.decreaseCounter();
            })
            .catch(() => {
                this.props.decreaseCounter();
            });
    }

    render () {

        const containerStyle = {
            // marginTop: '1%',
            // backgroundColor: '#f5f5f5',
            backgroundColor: 'white',
            border: '1px solid black',
            borderStyle: 'dotted',
            borderRadius: '4px',
            paddingLeft: '10px',
            marginLeft: '5px',
            marginRight: '5px',
            fontSize: '14px'
        };

        // const responses= {
        //     'COMPLAINT': '2' ,
        //     'CAUSE': '2',
        //     'CORRECT': '2' ,
        //     'SETTLEMENT': '2'
        //
        // }
        // const uploadStatus = "TOTAL UPDATED RECORDS : 100 Out-Off 130 Records."
        const valueStyleStart = {
            width: '2%',
            display: 'inline-block',
        };

        const valueStyleLeft = {
            width: '10%',
            display: 'inline-block',
            fontSize: '12px',
        };
        const valueStyleMidLeft = {
            width: '15%',
            display: 'inline-block',
            fontSize: '12px',
        };
        const valueStyleMiddle = {
            width: '2%',
            display: 'inline-block',
            fontSize: '12px',
            fontWeight:'bold'
        };
        const valueStyleRight = {
            width: '40%',
            display: 'inline-block',
            fontSize: '12px'
        };

        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <div className="massUpdate-page">
                    <div className="upload-label-batch">
                        <h2>Batch Text Data Upload</h2>
                    </div>
                    {/* <div className="sample-report-batch">
                        <a title="Field having values can update only" href={downloadSampleReports('text-extract-report')} download="text-extract-report.csv">Download Sample Report</a>
                    </div> */}
                    {/* <div className="sample-report-batch">
                        <a title="Field having values can update only"  onClick={this.handleDownloadClick('text-extract-report')}>Download Sample Report</a>
                    </div> */}
                    <div className="sample-report-batch">
                    <a
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('text-extract-report')}
                    >
                        Download Sample Report
                    </a>
                </div>
                    <FileUploadPanel
                        handleFileDrop={this.handleFileDrop}
                        handleRejectedFiles={this.handleRejectedFiles}
                        message={this.state.fileIcon}
                        handleSubmitClick={this.handleSubmitClick}
                        handleCancleClick={this.handleCancleClick}
                        fileName={this.state.fileInfo.name}
                    />
                </div>

                {/*<Accordion*/}
                {/*            accordionId="batch-text-upload"*/}
                {/*            title=""*/}
                {/*            isExpanded={false}*/}
                {/*            */}
                {/*        >*/}
                {/*             {*/}
                {/*        (!_.isEmpty(this.state.uploadResp)) ?*/}
                {/*        <div style ={{ marginTop : '1%' }}> */}
                {/*        */}
                {/*        {*/}
                {/*            this.state.uploadResp.map((item)=>*/}
                {/*           <li><small> {item} </small> </li>*/}
                {/*            )} </div> : null*/}

                {/*    } */}
                {/*            </Accordion>*/}


                {/*<div style={containerStyle}>*/}
                {/*    <b>{uploadStatus} &#9989; </b>*/}
                {/*            {*/}
                {/*        Object.entries(responses).map( ([key, value]) =>*/}
                {/*            <small>*/}
                {/*            <ul>*/}
                {/*                <li style={valueStyleStart}>&#10004;</li>*/}
                {/*                <li style={valueStyleLeft}>{key}</li>*/}
                {/*                <li style={valueStyleMidLeft}>TOTAL INSERT / UPDATE</li>*/}
                {/*                <li style={valueStyleMiddle}>:</li>*/}
                {/*                <li style={valueStyleRight}>{value}</li>*/}
                {/*            </ul>*/}
                {/*            </small>*/}
                {/*    )}*/}
                {/*    </div>*/}

                {
                    (!_.isEmpty(this.state.uploadResp)) ?
                        <div style={containerStyle}>
                            <span role="img" aria-label="image">{this.state.uploadStatus} &#9989; </span>
                            {
                                Object.entries(this.state.uploadResp).map( ([key, value]) =>
                                    <small>
                                        <ul>
                                            <li style={valueStyleStart}>&#10004;</li>
                                            <li style={valueStyleLeft}>{key}</li>
                                            <li style={valueStyleMidLeft}>TOTAL INSERT / UPDATE</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleRight}>{value}</li>
                                        </ul>
                                    </small>

                                )} </div> : null
                }

            </section>
        );

    }

}

BatchTextUpload.displayName = 'BatchTextUpload';
BatchTextUpload.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );

export default connect( mapStateToProps, mapDispatchToProps )( BatchTextUpload );
